<template>
  <div class="zt-menu-bar-wrapper">
    <div
      class="zt-menu-bar-button flex justify-center items-center relative cursor-pointer hidden lg:flex bg-white lg:shadow-lg"
      ref="ztButtonMenuBar"
      :aria-owns="computedOwns"
      v-on="listeners"
    >
      <zt-icon name="align-left" class="text-zt-lg" />
    </div>

    <transition>
      <div
        class="zt-menu-bar--list absolute overflow-hidden bg-zt-primary-200 hidden lg:block"
        :class="{ 'rounded-r-zt-md' : !permanent }"
        :id="computedOwns"
        ref="ztOptionsMenuBar"
        v-show="isActiveMenuBar"
        :style="styles"
        @mouseleave="closeMenuBar"
      >
        <div
          v-for="(option, index) in listOptions"
          :key="index"
          class="zt-menu-bar--list-options items-center bg-zt-primary-200 relative cursor-pointer"
          @click="closeMenuBar"
        >
          <router-link
            v-if="!option.url"
            :to="{ name: `${option.to}` }"
            class="w-full h-full flex justify-start items-center flex-wrap hover:no-underline"
          >
            <em class="flex flex-none justify-center items-center">
              <zt-icon :name="option.icon" class="text-white text-zt-lg" />
            </em>
            <span class="text-white flex-none">{{ option.name }}</span>
          </router-link>
          <a
            v-else
            @click="openUrl(option.url)"
            class="w-full h-full flex justify-start items-center flex-wrap hover:no-underline"
          >
            <em class="flex flex-none justify-center items-center">
              <zt-icon :name="option.icon" class="text-white text-zt-lg" />
            </em>
            <span class="text-white flex-none">{{ option.name }}</span>
          </a>
        </div>
        <div v-if="hasAdditionalMenu" class="zt-menu-bar--list-options items-center bg-zt-primary-200 relative cursor-pointer">
          <slot name="additional-menu"></slot>
        </div>
      </div>
    </transition>
    <div
      class="zt-menu-bar fixed flex justify-center items-center bg-zt-primary-200 bottom-0 left-0 right-0 lg:hidden"
    >
      <div
        v-for="(option, index) in visibleMobile"
        :key="index"
        class="zt-menu-bar--options relative cursor-pointer"
      >
        <router-link
          :to="{ name: `${option.to}` }"
          class="w-full h-full flex items-center justify-center flex-col"
        >
          <zt-icon
            :name="
              currentPage.includes(option.to)
                ? `${option.icon}-solid`
                : option.icon
            "
            class="text-white text-zt-xl"
          />
          <span class="text-white text-zt-xs font-light mt-1">{{
            option.shortName
          }}</span>
        </router-link>
      </div>
      <div class="zt-menu-bar--options relative cursor-pointer">
        <div
          class="w-full h-full flex items-center justify-center flex-col"
          @click="mouseHandlerProfile"
          @click.stop
        >
          <zt-icon name="person" class="text-white text-zt-xl" />
          <span class="text-white text-zt-xs font-light mt-1">Perfil</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ztMenuBar',
  inheritAttrs: false,
  props: {
    maxHeight: {
      type: String,
      default: '100vh'
    },
    maxWidth: {
      type: String,
      default: '270px'
    },
    permanent: {
      type: Boolean,
      default: false
    },
    listOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      listOptionsPart: [],
      isActiveMenuBar: false,
      isMenuOpened: false,
      styles: {}
    }
  },
  computed: {
    listeners() {
      const listeners = { ...this.$attrs };
      for (const key in this.$listeners) {
        if (!listeners[key]) {
          listeners[key] = (...args) => this.$emit(key, ...args);
        }
      }
      return {
        ...listeners,
        mouseenter: event => {
          this._onMouseEnter(event)
        },
        mouseleave: event => {
          this._onMouseLeave(event)
        },
        click: event => {
          this._onMouseClick(event)
        }
      }
    },
    computedOwns() {
      return `menu-list-${this._uid}`
    },
    currentPage() {
      return this.$route.path
    },
    visibleMobile() {
      return this.listOptions.filter(opt => opt.isMobile)
    },
    hasAdditionalMenu() {
      return !!this.$slots['additional-menu']
    }
  },
  mounted() {
    if (this.permanent) {
      this.isActiveMenuBar = true
      this.styles = this.stylesMenuBar()
      this.$emit('menu-update', this.styles)
    }
  },
  methods: {
    stylesMenuBar() {
      let buttonMenuBar = this.$refs.ztButtonMenuBar
      let topPos = 0
      let leftPos = 0
      if (buttonMenuBar) {
        const bbox = buttonMenuBar.getBoundingClientRect()
        topPos = bbox.height
        leftPos = bbox.width - buttonMenuBar.clientWidth
        if (this.permanent) {
          return {
            left: `${leftPos}px`,
            top: `${topPos}px`,
            height: `calc(${this.maxHeight} - ${bbox.height}px)`,
            width: this.isMenuOpened ? this.maxWidth : `${bbox.width}px`,
            zIndex: 11
          }
        }
      }
      return {
        left: `${leftPos}px`,
        top: `${topPos}px`,
        width: `${this.maxWidth}`,
        zIndex: 11
      }
    },
    _onMouseClick(event) {
      if (!this.permanent) return
      if (event.currentTarget === this.$refs.ztButtonMenuBar) {
        event.stopPropagation()
        this.isMenuOpened = !this.isMenuOpened
        this.styles = this.stylesMenuBar()
        this.$emit('menu-update', this.styles)
      }
    },
    _onMouseEnter(event) {
      if (this.permanent) return
      this.$emit('focus', event)
      this.isActiveMenuBar = true
      document.addEventListener('mouseenter', this.mouseLeave)
      this.$nextTick(() => {
        this.styles = this.stylesMenuBar()
      })
    },
    _onMouseLeave(event) {
      if (this.permanent) return
      if (
        event.relatedTarget
          ? !event.relatedTarget.closest('.zt-menu-bar--list')
          : false
      ) {
        this.closeMenuBar()
      }
      this.$emit('mouseleave', event)
    },
    mouseLeave(event) {
      let optionsMenuBar = event.target.closest('.zt-menu-bar--list')
      if (!optionsMenuBar) {
        this.closeMenuBar()
        this.styles = this.stylesMenuBar()
      }
    },
    closeMenuBar() {
      if (this.permanent) return
      this.isActiveMenuBar = false
      document.removeEventListener('mouseenter', this.mouseLeave)
    },
    mouseHandlerProfile(event) {
      this.$emit('click:profile', event)
    },
    openUrl(url) {
      window.open(url, '_blank')
    }
  },
  beforeDestroy() {
    let [parent] = document.getElementsByTagName('body')
    if (
      parent &&
      this.$refs.ztButtonMenuBar &&
      this.$refs.ztButtonMenuBar.parentNode === parent
    ) {
      parent.removeChild(this.$refs.ztButtonMenuBar)
      document.removeEventListener('mouseenter', this.mouseLeave)
    }
  }
}
</script>

<style
  scoped
  lang="css"
  src="../../../../styles/components/ztMenuBar.css"
></style>
